import { render, staticRenderFns } from "./PivotSettingsModal.vue?vue&type=template&id=73ccf58b"
import script from "./PivotSettingsModal.vue?vue&type=script&lang=js"
export * from "./PivotSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./PivotSettingsModal.vue?vue&type=style&index=0&id=73ccf58b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports